import { fetchToken } from "../../../common/FetchCookie";
import { BASE_URL, CORE, CORE_JOB_SKILLS } from "../../../common/URLs";

export const fetchJobSkills = async () => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_SKILLS}`; // Proxy path
  try {
          const token = await fetchToken()
    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    //   console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};

export const addJobSkill = async (newJobSkill) => {
  const url = `${BASE_URL}/${CORE}/${CORE_JOB_SKILLS}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newJobSkill),
    });
    const data = await response.json();
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};

export const updateJobSkill = async (uuid, jobSkillData) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_JOB_SKILLS}/${uuid}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(jobSkillData),
    });

    if (!response.ok) {
      throw new Error("Error updating job company: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error updating job company: " + error.message);
  }
};

export const deleteJobSkill = async (uuid) => {
  try {
    const token = await fetchToken()

    const response = await fetch(`${BASE_URL}/${CORE}/${CORE_JOB_SKILLS}/${uuid}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Error deleting job skill: " + response.statusText);
    }

    return await response.json();
  } catch (error) {
    throw new Error("Error deleting job skill: " + error.message);
  }
};
